export const OctigaBestPracticeBeginId = '0c716400';

export interface SwayTemplate {
    id: string;
    msp_id: string;
    name: string;
    created: string;
    type: 'tenant' | 'group';
}
